import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-lg border bg-card text-card-foreground shadow-sm px-1" }
const _hoisted_2 = { class: "flex flex-col space-y-1.5 p-6" }
const _hoisted_3 = { class: "font-semibold tracking-tight text-2xl" }
const _hoisted_4 = { class: "p-6 pt-0 -my-1 text-sm space-y-3" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Loan Size: ", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Execution types:", -1)
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, " Property types: ", -1)
const _hoisted_11 = { key: 3 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Footprint:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center p-6 pt-0" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/form" }, [
    /*#__PURE__*/_createElementVNode("button", { class: "inline-flex border border-sky text-sky items-center justify-center text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background bg-secondary text-secondary-foreground hover:bg-secondary/80 h-9 px-3 rounded-md hover:bg-sky hover:text-white" }, " Get a Quote   → ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.creditBox.AmountRange)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            _hoisted_6,
            (_ctx.creditBox.AmountRange.MinimumAmount && _ctx.creditBox.AmountRange.MaximumAmount)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" from " + _toDisplayString(_ctx.creditBox.AmountRange.MinimumAmount) + " to " + _toDisplayString(_ctx.creditBox.AmountRange.MaximumAmount), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.executionTypes.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.executionTypes), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.propertyTypes.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.propertyTypes), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.footprints.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.footprints), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_13
  ]))
}